export type Realisation = {
  id: string;
  title: string;
  category: "Mariage" | "Entreprise" | "Anniversaire" | "Thématique";
  city: string;
  venue?: string;
  guests: number;
  date: string;
  image: string;
  description: string;
  /** Slug de la page /lieux/* correspondante quand elle existe. */
  venueSlug?: string;
};

// Visuels temporaires Unsplash — à remplacer par vos vraies photos d'événements.
export const REALISATIONS: Realisation[] = [
  {
    id: "g1",
    title: "Mariage romantique au Château de Lourmarin",
    category: "Mariage",
    city: "Lourmarin (84)",
    venue: "Château de Lourmarin",
    guests: 110,
    date: "2024-06-22",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1000&q=72&auto=format&fit=crop",
    description: "Cérémonie laïque sous les platanes, cocktail dans la cour Renaissance, soirée dansante jusqu'à 4 h.",
  },
  {
    id: "g2",
    title: "Anniversaire 50 ans — Bastide d'Avignon",
    category: "Anniversaire",
    city: "Avignon (84)",
    guests: 80,
    date: "2024-11-02",
    image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=1000&q=72&auto=format&fit=crop",
    description: "Set inter-générationnel années 80 → hits actuels, lasers et machine à fumée lourde pour la première danse.",
  },
  {
    id: "g3",
    title: "Soirée d'entreprise Groupe Salinas",
    category: "Entreprise",
    city: "Aix-en-Provence (13)",
    venue: "Domaine de Saint-Estève",
    guests: 220,
    date: "2024-12-13",
    image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1000&q=72&auto=format&fit=crop",
    description: "Sono discours direction, fond musical du dîner, soirée dansante 220 personnes. Attestation SACEM fournie.",
  },
  {
    id: "g4",
    title: "Mariage franco-marocain — Domaine du Petit Sonnailler",
    category: "Mariage",
    city: "Aix-en-Provence (13)",
    venue: "Domaine du Petit Sonnailler",
    guests: 160,
    date: "2024-07-13",
    image: "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=1000&q=72&auto=format&fit=crop",
    description: "Fusion playlist orientale et hits internationaux, ambiance fédératrice toute la nuit.",
  },
  {
    id: "g5",
    title: "Arbre de Noël EDF Sud — 350 personnes",
    category: "Entreprise",
    city: "Orange (84)",
    guests: 350,
    date: "2024-12-06",
    image: "https://images.unsplash.com/photo-1543007630-9710e4a00a20?w=1000&q=72&auto=format&fit=crop",
    description: "Animation famille en journée puis soirée adultes. Régie son XL, micros HF, line-array RCF.",
  },
  {
    id: "g6",
    title: "Mariage intime à Bonnieux",
    category: "Mariage",
    city: "Bonnieux (84)",
    venue: "Bastide Saint-Joseph",
    guests: 85,
    date: "2024-08-17",
    image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=1000&q=72&auto=format&fit=crop",
    description: "Format intimiste, ambiance jazzy au cocktail, soirée dansante fédératrice sans excès.",
  },
  {
    id: "g7",
    title: "Soirée à thème années 80",
    category: "Thématique",
    city: "Apt (84)",
    guests: 50,
    date: "2024-02-10",
    image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1000&q=72&auto=format&fit=crop",
    description: "Déco lumineuse, lasers RGB, set 100 % 80s avec quelques pépites italo-disco.",
  },
  {
    id: "g8",
    title: "Mariage bohème à Roussillon",
    category: "Mariage",
    city: "Roussillon (84)",
    venue: "Mas de la Beaume",
    guests: 75,
    date: "2024-09-21",
    image: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=1000&q=72&auto=format&fit=crop",
    description: "Ambiance bohème, guirlandes guinguette, set folk → électro douce, dancefloor extérieur.",
  },
  {
    id: "g9",
    title: "Inauguration locaux Studio Helios",
    category: "Entreprise",
    city: "Avignon (84)",
    venue: "Hôtel de l'Atelier",
    guests: 60,
    date: "2025-01-25",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1000&q=72&auto=format&fit=crop",
    description: "Cocktail dînatoire 4 h, fond musical lounge, micro HF pour les prises de parole.",
  },
  {
    id: "g10",
    title: "60 ans surprise — Cavaillon",
    category: "Anniversaire",
    city: "Cavaillon (84)",
    guests: 60,
    date: "2024-03-09",
    image: "https://images.unsplash.com/photo-1496337589254-7e19d01cec44?w=1000&q=72&auto=format&fit=crop",
    description: "Répertoire 70s/80s précis, machine à fumée lourde pour la première danse père-fille.",
  },
  {
    id: "g11",
    title: "Mariage Bastide de Gordes",
    category: "Mariage",
    city: "Gordes (84)",
    venue: "Bastide de Gordes",
    guests: 140,
    date: "2024-09-14",
    image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1000&q=72&auto=format&fit=crop",
    description: "Vue panoramique sur le Luberon, sono extérieure RCF, dancefloor 4 h sans pause.",
  },
  {
    id: "g12",
    title: "Cocktail 15 ans Cabinet Mercier",
    category: "Entreprise",
    city: "Marseille (13)",
    venue: "Villa Gaby",
    guests: 180,
    date: "2024-10-25",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1000&q=72&auto=format&fit=crop",
    description: "Sonorisation discours + bascule en soirée dansante. Équipe réceptive et matériel pro.",
  },
  {
    id: "g13",
    title: "Mariage au Domaine Malaugo",
    category: "Mariage",
    city: "Robion (84)",
    venue: "Domaine Malaugo",
    venueSlug: "domaine-malaugo",
    guests: 130,
    date: "2025-06-14",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1000&q=72&auto=format&fit=crop",
    description: "Cocktail sous les oliviers, ouverture de bal en extérieur puis bascule en salle voûtée jusqu'à 3 h.",
  },
  {
    id: "g14",
    title: "Mariage à La Grange de Javon",
    category: "Mariage",
    city: "Lioux (84)",
    venue: "La Grange de Javon",
    venueSlug: "la-grange-de-javon",
    guests: 120,
    date: "2025-07-05",
    image: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=1000&q=72&auto=format&fit=crop",
    description: "Cérémonie laïque sonorisée dans le parc, dîner sous la charpente, dancefloor plein dès 22 h 30.",
  },
  {
    id: "g15",
    title: "Mariage au Domaine de Manville",
    category: "Mariage",
    city: "Les Baux-de-Provence (13)",
    venue: "Domaine de Manville",
    venueSlug: "domaine-de-manville",
    guests: 150,
    date: "2025-09-06",
    image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1000&q=72&auto=format&fit=crop",
    description: "Sonorisation discrète au cocktail, régie soirée aux Alpilles avec contrainte de niveau sonore maîtrisée.",
  },
  {
    id: "g16",
    title: "Anniversaire au Petit Roulet",
    category: "Anniversaire",
    city: "Cavaillon (84)",
    venue: "Le Petit Roulet",
    venueSlug: "le-petit-roulet",
    guests: 90,
    date: "2025-05-24",
    image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=1000&q=72&auto=format&fit=crop",
    description: "40 ans en extérieur : apéro lounge, set festif multi-générations, éclairage architectural du mas.",
  },
  {
    id: "g17",
    title: "Séminaire au Domaine d'Egenia",
    category: "Entreprise",
    city: "Caumont-sur-Durance (84)",
    venue: "Domaine d'Egenia",
    venueSlug: "domaine-d-egenia",
    guests: 140,
    date: "2025-10-17",
    image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1000&q=72&auto=format&fit=crop",
    description: "Sono conférence le jour, soirée de gala le soir : deux configurations, une seule installation.",
  },
];

export const REALISATION_CATEGORIES = ["Tous", "Mariage", "Entreprise", "Anniversaire", "Thématique"] as const;
